import create from "zustand";
import { persist } from "zustand/middleware";

type Auth0Token = {
  token: string;
};

type Auth0TokenState = {
  auth0Token: Auth0Token | null | undefined;
  setAuth0Token: (state: Auth0Token | null | undefined) => void;
};

const useAuth0TokenStore = create(
  persist<Auth0TokenState>(
    (set) => ({
      auth0Token: null,
      setAuth0Token: (auth0Token) => set({ auth0Token }),
    }),
    {
      name: "auth0-token",
    }
  )
);

const useAuth0Token = () => {
  const { auth0Token, setAuth0Token } = useAuth0TokenStore();

  return { auth0Token, setAuth0Token };
};

export default useAuth0Token;
